import { Color, Engine, Material } from "excalibur";

export const createTintedMaterial = (
  engine: Engine,
  tintColor: Color,
  opacity: number = 0.5
): Material => {
  const [r, g, b] = [tintColor.r / 255, tintColor.g / 255, tintColor.b / 255]; // Normalize color to 0-1

  return engine.graphicsContext.createMaterial({
    name: "custom-material",
    fragmentSource: `#version 300 es
          precision mediump float;

          in vec2 v_uv;
          out vec4 fragColor;
          uniform vec2 u_graphic_resolution;
          uniform sampler2D u_graphic;

          vec2 uv_iq(in vec2 uv, in vec2 texture_size) {
            vec2 pixel = uv * texture_size;
            vec2 seam = floor(pixel + 0.5);
            vec2 dudv = fwidth(pixel);
            pixel = seam + clamp((pixel - seam) / dudv, -0.5, 0.5);
            return pixel / texture_size;
          }

          void main(void) {
              vec2 newUv = uv_iq(v_uv, u_graphic_resolution);
              vec4 sourceColor = texture(u_graphic, newUv);

              // Apply custom tint
              vec3 customTint = vec3(${r.toFixed(3)}, ${g.toFixed(
      3
    )}, ${b.toFixed(3)});
              sourceColor.rgb = mix(sourceColor.rgb, customTint, ${opacity}); // Blend with the tint color

              fragColor = sourceColor;
              fragColor.rgb = fragColor.rgb * fragColor.a; // Premultiply alpha
          }`,
  });
};
